import type {
    CycleEvaluationGroup,
    CycleEvaluationGroupChild,
} from '@/types/cycle-evaluation/CycleEvaluationGroup';

import { CycleEvaluationStatus } from '@/constants/cycle-evaluation/CycleEvaluation';

export const isDormantCycleEvaluation = (child: CycleEvaluationGroupChild): boolean =>
    child.status === CycleEvaluationStatus.INACTIVE;

export const partitionDormantCycleEvaluations = (
    group: CycleEvaluationGroup,
): CycleEvaluationGroup => {
    const children = group.cycleEvaluations ?? [];

    return {
        ...group,
        cycleEvaluations: children.filter((child) => !isDormantCycleEvaluation(child)),
        dormantCycleEvaluations: children.filter(isDormantCycleEvaluation),
    };
};
